<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 101 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planType: 101, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode']"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, planType: 101 }"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode || organizationCodeOrigin }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="MRP版本">
              <global-select
                ref="mrpSelectRef"
                v-decorator="['mrpVersionNumber', { rules: [{ required: true }] }]"
                selectType="selectSearch"
                :selectItem="{ value: 'realValue', label: 'label' }"
                requestApi="/scp/scpMrpPlans/mrpVersionNumberBox"
                searchParam="mrpVersionNumber"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(form.getFieldsValue())">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
          <a-row class="align-center">
            <a-button @click="handleExport" v-hasPermi="['scp:scpMrpHorizontalSummary:rawMaterialExport']">导出</a-button>
            <a-col :md="7" :sm="24" class="ml50">
              <a-form-item label="主计划版本">
                <a-input v-model="planVersion" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="计划运算完成时间" :labelCol="{ style: { width: '120px' } }">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
        >
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpHorizontalSummaryRawMaterialList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpScreeningSchemeSearchAllScheme,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpHorizontalDatesDateDisplayList
} from '@/api/scp/reserve-goods-plan/material-demand-query'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { generateLsTableResData } from '@/utils/util.js';
export default {
  // eslint-disable-next-line
  name: 'Material-demand-query', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DressingByScreening,
    DressingByScreeningSetUp
  },
  data () {
    return {
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpHorizontalSummaryRawMaterialList, true),
        pageCurrent: true
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2200,
      tableList: [],
      // 表格字段
      columnsOrigin: [],
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 120,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 120,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: '加工商',
          dataIndex: 'demandSupplierName',
          align: 'center'
        },
        {
          title: '材料商',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          align: 'center',
          ellipsis: true
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          align: 'center',
          ellipsis: true
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          align: 'center',
          ellipsis: true
        },
        {
          title: 'MPQ',
          dataIndex: 'fixedLotMultiplier',
          align: 'center'
        },
        {
          title: 'MOQ',
          dataIndex: 'moq',
          align: 'center'
        },
        {
          title: '库存',
          dataIndex: 'onhand',
          align: 'center'
        },
        {
          title: '总数量',
          dataIndex: 'summary',
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        },
        {
          title: 'MRP版本',
          dataIndex: 'mrpVersionNumber',
          align: 'center'
        }
      ],
      searchList1: [],
      searchList2: [],
      treeData: [], // 物料类别
      planVersion: "", // 主计划版本
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "" // 计划运算完成时间
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.columnsOrigin = JSON.parse(JSON.stringify(this.columns))
    this.getCategoryIdList(true)
    this.getSearchAllScheme()
  },
  mounted () {},
  methods: {
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      if (!this.form.getFieldsValue().mrpVersionNumber) {
        this.$message.warning('MRP版本不能为空')
        return;
      }
      this.isEdit = false
      this.getTableTime()
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.form.resetFields()
      this.$nextTick(() => {
        this.form.setFieldsValue(JSON.parse(val.schemeDetailJson))
        console.log(val, this.form)
        this.onSearch()
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.tableList = [];
      if (this.$refs?.mrpSelectRef) {
        this.$refs.mrpSelectRef.handleSearch("");
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpHorizontalSummary/rawMaterialExport', {
        ...this.form.getFieldsValue()
      }, `原材料毛需求查询_${new Date().getTime()}.xlsx`)
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.form.setFieldsValue(JSON.parse(element.schemeDetailJson))
              this.onSearch()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    getTableTime () {
      // 数据收集时间、计划运算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.form.getFieldsValue()).then(res => {
        if (res.data) {
          this.planVersion = res.data.scheduleVersion
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      // 动态表头
      apiScpMrpHorizontalDatesDateDisplayList({ planVersion: this.form.getFieldsValue().planVersion, dataType: "CALL" }).then(res => {
        if (res.data && res.data.length > 0) {
          const columns = JSON.parse(JSON.stringify(this.columnsOrigin))
          const arr = res.data
          arr.forEach((element, index) => {
            const obj = {
              title: element,
              dataIndex: `date${index + 1}`
            }
            columns.splice(-2, 0, obj);
          });
          this.columns = columns
          this.tableX = 2200 + res.data.length * 100
        } else {
          this.columns = JSON.parse(JSON.stringify(this.columnsOrigin))
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
</style>
